import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { getSessionData } from '@confluence/session-data/entry-points/SessionData';
import { getUserPermissionFromQuery } from '@confluence/external-collab-ui/entry-points/getUserPermissionFromQuery';
import {
	GlobalOperationsUserPermissionTypeQuery,
	SitePermissionType,
} from '@confluence/external-collab-ui/entry-points/GlobalOperationsUserPermissionTypeQuery';
import type { GlobalOperationsUserPermissionTypeQueryType as GlobalOperationsUserPermissionType } from '@confluence/external-collab-ui/entry-points/GlobalOperationsUserPermissionTypeQuery';

export const getCanViewUserProfile = async (): Promise<boolean> => {
	await getSessionData();

	// External Collaborators should not have access to view user profile
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	const { data: userPermissionData }: any = await getApolloClient()
		.query<GlobalOperationsUserPermissionType>({
			query: GlobalOperationsUserPermissionTypeQuery,
			errorPolicy: 'all',
		})
		.catch((error) => {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
			markErrorAsHandled(error);
			return new Error('PERMISSION ERROR');
		});

	const isExternalCollaborator =
		getUserPermissionFromQuery(userPermissionData) === SitePermissionType.EXTERNAL;

	return !isExternalCollaborator;
};
